<!--suppress ALL -->
<template>
    <div class="price-table">
        <vue-easy-lightbox
                :visible="image_show_fsize"
                :imgs="image_show_path"
                @hide="close_image"
        >
        </vue-easy-lightbox>
    <v-card>
        <v-card-title>
            <v-layout column>
                <v-layout row wrap align-top justify-space-between>
                    <v-flex xs12 md5>
                        <v-autocomplete :disabled="disable_control"
                                        append-outer-icon="sync" @click:append-outer="filter_brands(false)"
                                        @click:clear="filter_brands(true)"
                                        @change="filter_brands(false)"
                                        v-model="selected_brands"
                                        :items="payload_brands"
                                        label="Фильтр по брэндам"
                                        item-text="name" item-value="id"
                                        multiple clearable
                        >
                            <template slot="selection" slot-scope="{ item, index }">
                                <v-chip close small v-if="index < 5"
                                        @input="[selected_brands.splice(index, 1)]">
                                    <span>{{ item.name }}</span>
                                </v-chip>
                                <span
                                        v-if="index === 5"
                                        class="grey--text caption"
                                >(+{{ selected_brands.length - 5 }} других)</span>
                            </template>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md5>
                        <v-text-field :disabled="disable_control"
                                      v-model="search"
                                      @click:prepend="perform_search(false)"
                                      @click:clear="perform_search(true)"
                                      v-on:keyup.enter="perform_search(false)"
                                      clearable clear-icon="backspace"
                                      prepend-icon="search" label="Поиск" single-line hide-details
                                      placeholder="Поиск: по названию, артикулу или брэнду"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row wrap align-top justify-space-between>
                    <v-flex xs12 sm6 md3>
                        <v-select :items="rests_filter_list" :disabled="disable_control"
                                  label="Фильтр остатков" v-model="rests_value"
                                  @change="toggle_rests_view">
                        </v-select>
                    </v-flex>
                    <v-flex xs12 sm6 md3>
                        <v-layout row wrap align-center justify-space-between>
                            <v-flex xs2 shrink>
                                <v-btn small
                                       :disabled="disable_control"
                                       outline flat class="grey--text"
                                       style="min-width: 10px; width: 25px;"
                                       @click="toggle_price_dir">
                                    <v-icon>{{price_filter_dir === "__gte" ? "keyboard_arrow_right" :
                                        "keyboard_arrow_left"}}
                                    </v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex xs10>
                                <v-text-field :disabled="disable_control"
                                              v-model.number="price_filter_value" min="0" step="50" type="number"
                                              append-outer-icon="sync"
                                              @click:append-outer="perform_filter_price(false)"
                                              @click:clear="perform_filter_price(true)"
                                              v-on:keyup.enter="perform_filter_price(false)"
                                              clearable clear-icon="backspace" label="Фильтр по ценам"
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm8 md6>
                        <v-layout row wrap align-top justify-space-between>
                            <v-flex>
                                <v-checkbox :disabled="disable_control"
                                            color="primary" v-model="cat_new"
                                            hint="Новинки" persistent-hint @change="filter_by_category('new')">
                                    <span slot="label" class="primary--text">NEW</span>
                                </v-checkbox>
                            </v-flex>
                            <v-flex>
                                <v-checkbox :disabled="disable_control"
                                            color="accent" v-model="cat_promo"
                                            hint="Акции" persistent-hint @change="filter_by_category('promo')">
                                    <span slot="label" class="accent--text">АКЦИЯ</span>
                                </v-checkbox>
                            </v-flex>
                            <v-flex>
                                <v-checkbox :disabled="disable_control"
                                            color="success" v-model="cat_sale"
                                            hint="Распродажа" persistent-hint @change="filter_by_category('sale')">
                                    <span slot="label" class="success--text text--darken-1">SALE</span>
                                </v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout row wrap align-top justify-space-between>
                    <v-flex xs4 sm2 md1>
                        <v-select :disabled="disable_control"
                                  :items="rows_per_page" label="На стр."
                                  @change="pagination_change_rowsPerPage"
                                  v-model="pagination.rowsPerPage">
                        </v-select>
                    </v-flex>
                    <v-flex xs4 sm2 md1>
                        <v-tooltip bottom color="secondary">
                            <template v-slot:activator="{ on }">
                                <v-checkbox :disabled="disable_control"
                                            @change="session_settings_save"
                                            v-on="on"
                                            v-model="autoload_on_bottom"
                                            color="primary"
                                            on-icon="sync"
                                            off-icon="sync_disabled"
                                ></v-checkbox>
                            </template>
                            <p class="warning--text font-weight-bold">Динамическая подгрузка товаров.</p>
                            <p>
                                При достижении конца текущей страницы<br>
                                товары из следующей страницы будут автоматически<br>
                                загружены и добавлены к текущему списку.
                            </p>
                        </v-tooltip>
                    </v-flex>
                    <v-flex xs12 sm8 md7>
                        <div class="text-xs-center pt-2">
                            <v-pagination
                                    :v-model="payload_meta.pagination"
                                    :length="payload_meta.pagination.pages"
                                    :value="pagination.selected_page"
                                    :disabled="disable_control || payload_meta.pagination.pages === 1"
                                    prev-icon="mdi-menu-left" next-icon="mdi-menu-right"
                                    class="info--text"
                                    @input="navigate_pagination"
                            >
                            </v-pagination>
                        </div>
                    </v-flex>
                    <v-flex xs12 sm4 md3>
                        <div class="caption pa-1" style="border: 1px solid #adadad; border-radius: 2px;">
                            <div>
                                <v-tooltip bottom color="secondary">
                                    <template v-slot:activator="{ on }">
                                        <p style="margin-bottom: 0px">
                                            Товаров отобрано:
                                            <span class="primary--text font-weight-bold">{{payload_meta.pagination.count}}</span>
                                            <v-icon right v-on="on" style="float: right;"
                                                    color="accent">info_outline
                                            </v-icon>
                                        </p>
                                    </template>
                                    <p>Фильтрация происходит автоматически после выбора или ввода значения.</p>
                                    <p>Нажмите
                                        <v-icon color="warning">sync</v-icon>
                                        или клавишу <span class="warning--text font-weight-bold">ENTER</span>
                                        для применения фильтра по брэндам вручную.<br>
                                        Нажмите
                                        <v-icon color="warning">sync</v-icon>
                                        или клавишу <span class="warning--text font-weight-bold">ENTER</span>
                                        для применения фильтра по ценам вручную.<br>
                                        Нажмите
                                        <v-icon color="warning">search</v-icon>
                                        или клавишу <span class="warning--text font-weight-bold">ENTER</span> для
                                        применения
                                        поиска.
                                    </p>
                                    <p>Фильтрация по категориям возможна только по одной из существующих.</p>
                                    <p class="warning--text font-weight-bold">Вся фильтрация происходит с учетом
                                        выбранных
                                        каталогов.</p>
                                </v-tooltip>
                            </div>
                            <span>Каталоги поиска:</span>
                            <template v-if="selected_catalogs.items.length > 0">
                                <p class="font-weight-medium" style="margin-bottom: 0px">
                                    {{selected_catalogs.items[0].name}}
                                </p>
                                <p v-if="selected_catalogs.items.length > 1"
                                   class="font-weight-medium info--text" style="margin-bottom: 0px">
                                    (и др. {{selected_catalogs.items.length-1}} выбрано)
                                </p>
                            </template>
                            <template v-else>
                                <p :class="['font-weight-medium', selected_catalogs.all ? 'primary--text' : '']"
                                   style="margin-bottom: 0px">
                                    {{selected_catalogs.all ? 'Весь каталог' : 'не выбраны'}}
                                </p>
                            </template>
                        </div>
                    </v-flex>
                </v-layout>
            </v-layout>
        </v-card-title>

        <div class="table-container hidden-sm-and-down">
            <v-data-table
                    :headers="headers"
                    :items="payload_list" item-key="id"
                    :pagination.sync="pagination"
                    :rows-per-page-items="rows_per_page"
                    :loading="is_loading_table"
                    :expand="row_expanded"
                    hide-actions class="elevation-1"
                    :total-items="payload_meta.pagination.count"
            >
                <v-progress-linear slot="progress" color="accent" indeterminate></v-progress-linear>

                <template slot="headers" slot-scope="props">
                    <tr>
                        <template v-for="header in props.headers">
                            <template v-if="header.selected">
                                <th v-if="header.sortable" :key="header.text"
                                        :class="['text-xs-' + header.align, 'column sortable', pagination.descending ? 'desc' : 'asc', header.sort_value === pagination.sortBy ? 'active' : '']"
                                        @click="change_sort(header.sort_value)">
                                    <v-icon small>arrow_upward</v-icon>
                                    {{ header.text }}
                                </th>
                                <th v-else class="column" :key="header.text">
                                    {{ header.text }}
                                </th>
                            </template>
                        </template>
                        <th class="column" v-if="is_logged_in">
                            <v-icon>add_shopping_cart</v-icon>
                        </th>
                    </tr>
                </template>

                <template slot="items" slot-scope="props">
                    <tr>
                        <td @click="props.expanded = !props.expanded">
                            <p v-if="props.item.category_new || props.item.category_promo || props.item.category_sale"
                            style="margin-bottom: 0px;">
                                <span v-if="props.item.category_new"
                                      class="primary--text">[NEW] </span>
                                <span v-if="props.item.category_promo"
                                      class="accent--text">[АКЦИЯ] </span>
                                <span v-if="props.item.category_sale"
                                      class="success--text text--darken-1">[SALE] </span>
                            </p>
                            {{ props.item.name }}
                        </td>
                        <td @click="props.expanded = !props.expanded">{{ props.item.article }}</td>
                        <td width="110px">
                            <v-img  style="cursor: pointer;"
                                    @click="view_image(props.item.image_path)"
                                    contain width="100px" max-height="100px"
                                    :src="props.item.image_path">
                                <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                </v-layout>
                            </v-img>
                        </td>
                        <td @click="props.expanded = !props.expanded" class="text-xs-center">{{ props.item.name_brand }}</td>
                        <td @click="props.expanded = !props.expanded" class="accent--text body-2 text-xs-right">
                            {{ props.item.price_user.value }}
                        </td>
                        <td @click="props.expanded = !props.expanded" class="text-xs-right">{{ props.item.price_pub.value }}</td>
                        <td @click="props.expanded = !props.expanded"
                            :class="['text-xs-right', props.item.rests.value > 0 ? '' : 'error--text' ]" style="padding-right: 10px;">
                            {{ props.item.rests.value > 0 ? props.item.rests.value_masked : 'нет'}}</td>
                        <td v-if="is_logged_in" width="50px">
                            <v-edit-dialog
                                large lazy
                                @open="open_item_to_cart()"
                                @save="save_item_to_cart(props.item, order_item_send_qty)"
                                cancel-text="Отмена"
                                save-text="В заказ"
                            >
                                <v-btn flat icon fab small v-bind:class="[
                                    order_items_list.indexOf(props.item.id) > -1 ? 'primary--text' : 'info--text']">
                                    <v-icon large>add_circle_outline</v-icon>
                                </v-btn>
                                <div slot="input" class="mt-3 title">Введите количество</div>
                                <v-text-field
                                    slot="input" v-model.number="order_item_send_qty" min="1" step="10"
                                    label="QTY" single-line autofokus
                                    append-outer-icon="add_circle_outline"
                                        @click:append-outer="order_item_send_qty+=1"
                                    prepend-icon="remove_circle_outline"
                                        @click:prepend="[order_item_send_qty > 1 ? order_item_send_qty-=1 : order_item_send_qty=1]"
                                    suffix="шт." type="number"
                                    v-on:keyup.enter="save_item_to_cart(props.item, order_item_send_qty)"
                                ></v-text-field>
                                <div slot="input" class="mt-3 subheading">
                                    <p>Стоимость: <b>{{order_item_send_qty * props.item.price_user.value | TO_PRICE}}</b></p>
                                    <p>Доступный остаток:
                                        <span :class="[props.item.rests.value > 0 ? '' : 'error--text']">
                                            {{props.item.rests.value > 0 ? props.item.rests.value_masked + ' шт.' : 'нет на складе!'}}
                                        </span>
                                    </p>
                                </div>
                            </v-edit-dialog>

                        </td>
                    </tr>
                </template>

                <template slot="expand" slot-scope="props">
                    <v-card flat class="info lighten-2">
                        <v-card-text>
                            <v-layout row>
                                <v-flex xs1 md1 align-self-center>
                                    <v-icon>keyboard_capslock</v-icon>
                                </v-flex>
                                <v-flex xs2 md2 align-self-center>
                                    Каталог: <b>{{props.item.id_parent.name}}</b>
                                </v-flex>
                                <v-divider vertical></v-divider>
                                <v-flex xs7 md7 align-self-center>{{props.item.description}}</v-flex>
                                <v-divider vertical></v-divider>
                                <v-flex xs2 md2 align-self-center style="font-family: monospace;">
                                    Штук в кор.: {{props.item.package_qty}}
                                    <br />
                                    ШК шт. : {{props.item.sku_pcs}}
                                    <br />
                                    ШК кор.: {{props.item.sku_pkg}}
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </template>

                <v-alert outline slot="no-results" :value="true" color="error" icon="warning">
                    По запросу <b>"{{ search }}"</b> ничего не найдено.
                </v-alert>
                <template v-if="alert.icon === 'touch_app'">
                    <v-alert slot="no-data" :value="true" class="pointer-element"
                             :color="alert.color"
                             @click="catalog_toggle">
                        <v-icon class="white--text mr-2">{{ alert.icon }}</v-icon>
                        <span>{{ alert.text }}</span>
                    </v-alert>
                </template>
                <template v-else>
                    <v-alert outline slot="no-data" :value="true"
                             :color="alert.color" :icon="alert.icon">
                        {{ alert.text }}
                    </v-alert>
                </template>
            </v-data-table>
        </div>

        <div class="hidden-md-and-up">
            <v-data-iterator content-tag="v-layout" row wrap
                    :items="payload_list" item-key="id"
                    :pagination.sync="pagination"
                    :rows-per-page-items="rows_per_page"
                    hide-actions class="elevation-1"
                    :total-items="payload_meta.pagination.count"
            >
                <template slot="header">
                    <v-layout row align-center justify-space-between mx-2>
                        <v-flex xs10>
                            <v-select :disabled="disable_control"
                                      :items="mob_sort_list" label="Сортировать по:"
                                      @change="mob_change_sort"
                                      v-model="pagination.sortBy">
                            </v-select>
                        </v-flex>
                        <v-flex xs2>
                            <v-checkbox :disabled="disable_control"
                                        @change="mob_change_sort"
                                        v-model="pagination.descending"
                                        color="primary"
                                        :true-value="false"
                                        :false-value="true"
                                        on-icon="trending_up"
                                        off-icon="trending_down"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                    <v-progress-linear color="accent" indeterminate
                                       v-if="is_loading_table"></v-progress-linear>
                </template>

                <template slot="item" slot-scope="props">
                    <v-flex xs12 sm6 md4 lg3>
                        <v-card>
                            <v-card-title class="mob_item_title mob_item_title_text--text mob-s-item-title">
                                <v-layout row wrap align-center justify-space-between>
                                    <v-flex xs10>
                                        <span class="body-1 font-weight-bold">{{ props.item.article }}</span>
                                    </v-flex>
                                    <v-flex xs2 v-if="is_logged_in">
                                        <v-edit-dialog
                                                large lazy
                                                @open="open_item_to_cart()"
                                                @save="save_item_to_cart(props.item, order_item_send_qty)"
                                                cancel-text="Отмена"
                                                save-text="В заказ"
                                        >
                                            <v-btn flat icon fab small
                                                   v-bind:class="['btn-mini', order_items_list.indexOf(props.item.id) > -1 ?
                                                   'mob_item_btn_in_cart--text' : 'mob_item_title_text--text']">
                                                <v-icon medium>add_circle_outline</v-icon>
                                            </v-btn>
                                            <div slot="input" class="mt-3 title">Введите количество</div>
                                            <v-text-field
                                                    slot="input" v-model.number="order_item_send_qty"
                                                    min="1" step="10"
                                                    label="QTY" single-line autofokus
                                                    append-outer-icon="add_circle_outline"
                                                    @click:append-outer="order_item_send_qty+=1"
                                                    prepend-icon="remove_circle_outline"
                                                    @click:prepend="[order_item_send_qty > 1 ? order_item_send_qty-=1 : order_item_send_qty=1]"
                                                    suffix="шт." type="number"
                                                    v-on:keyup.enter="save_item_to_cart(props.item, order_item_send_qty)"
                                            ></v-text-field>
                                            <div slot="input" class="mt-3 subheading">
                                                <p>Стоимость: <b>{{order_item_send_qty * props.item.price_user.value |
                                                    TO_PRICE}}</b></p>
                                                <p>Доступный остаток:
                                                    <span :class="[props.item.rests.value > 0 ? '' : 'error--text']">
                                                        {{props.item.rests.value > 0 ?
                                                        props.item.rests.value_masked + ' шт.' : 'нет на складе!'}}
                                                    </span>
                                                </p>
                                            </div>
                                        </v-edit-dialog>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                            <v-divider></v-divider>
                            <p v-if="props.item.category_new || props.item.category_promo || props.item.category_sale"
                               class="ml-3 mt-2"
                               style="margin-bottom: 0px;">
                                <span v-if="props.item.category_new"
                                      class="primary--text">[NEW] </span>
                                <span v-if="props.item.category_promo"
                                      class="accent--text">[АКЦИЯ] </span>
                                <span v-if="props.item.category_sale"
                                      class="success--text text--darken-1">[SALE] </span>
                            </p>
                            <p class="ml-3 mt-2" style="margin-bottom: 0px">
                                {{ props.item.name }}
                            </p>
                            <v-divider></v-divider>
                            <v-flex layout style="min-height: 50px; max-height: 120px">
                                <v-img style="cursor: pointer;"
                                       @click="view_image(props.item.image_path)"
                                       contain
                                       :src="props.item.image_path">
                                    <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                                    </v-layout>
                                </v-img>
                            </v-flex>
                            <v-divider></v-divider>
                            <v-list dense>
                                <v-list-tile>
                                    <v-list-tile-content>Брэнд:</v-list-tile-content>
                                    <v-list-tile-content class="align-end">{{ props.item.name_brand }}</v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>Цена:</v-list-tile-content>
                                    <v-list-tile-content class="align-end accent--text body-2">{{ props.item.price_user.value | TO_PRICE }}</v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>РРЦ:</v-list-tile-content>
                                    <v-list-tile-content class="align-end">{{ props.item.price_pub.value | TO_PRICE }}</v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>Остаток:</v-list-tile-content>
                                    <v-list-tile-content
                                            :class="['text-xs-right',
                                            'align-end',
                                            props.item.rests.value > 0 ?
                                            '' : 'error--text' ]">
                                        {{ props.item.rests.value > 0 ? props.item.rests.value_masked : 'нет'}}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-expansion-panel>
                                    <v-expansion-panel-content class="grey lighten-2">
                                        <template v-slot:header>
                                            <span class="body-1">Дополнительно</span>
                                        </template>
                                        <v-card flat class="grey lighten-4">
                                            <v-card-text>
                                                <v-layout row wrap>
                                                    <v-flex xs12 align-self-center>
                                                        <span class="font-weight-bold">Каталог:</span>
                                                        {{props.item.id_parent.name}}
                                                    </v-flex>
                                                    <v-divider style="border: 1px solid #90A4AE;"></v-divider>
                                                    <v-flex xs12 align-self-center style="font-family: monospace;">
                                                        Штук в кор.: {{props.item.package_qty}}
                                                        <br/>
                                                        ШК шт. : {{props.item.sku_pcs}}
                                                        <br/>
                                                        ШК кор.: {{props.item.sku_pkg}}
                                                    </v-flex>
                                                    <v-divider style="border: 1px solid #90A4AE;"></v-divider>
                                                    <v-flex xs12 align-self-center>
                                                        <span class="font-weight-bold">Описание:</span>
                                                        {{props.item.description}}
                                                    </v-flex>
                                                </v-layout>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>

                            </v-list>

                        </v-card>
                    </v-flex>
                </template>

                <v-alert class="mx-2" outline slot="no-results" :value="true" color="error" icon="warning">
                    По запросу <b>"{{ search }}"</b> ничего не найдено.
                </v-alert>
                 <template v-if="alert.icon === 'touch_app'">
                    <v-alert class="mx-2 pointer-element" slot="no-data"
                             :value="true" :color="alert.color" :icon="alert.icon"
                             style="color: white !important;"
                             @click="catalog_toggle">
                        <span>{{ alert.text }}</span>
                    </v-alert>
                </template>
                <template v-else>
                    <v-alert class="mx-2" outline slot="no-data" :value="true"
                             :color="alert.color" :icon="alert.icon">
                        {{ alert.text }}
                    </v-alert>
                </template>

            </v-data-iterator>
        </div>

        <div class="text-xs-center pt-2">
            <transition name="el-fade" mode="out-in">
                <v-progress-circular
                        v-if="is_loading_chunk"
                        class="mb-3"
                        :indeterminate="true"
                        color="accent"
                        :size="70"
                        :width="7">
                </v-progress-circular>
            </transition>
        </div>

        <v-snackbar v-model="snack.active" :timeout="snack.timeout" :color="snack.color">
            {{ snack.text }}
            <v-btn flat @click="snack.active = false" :ripple="false">Закрыть</v-btn>
        </v-snackbar>
    </v-card>
    </div>
</template>

<script>
    import $ from 'jquery'
    import { Globals } from '@/globals.js';
    export default {
        name: "PriceTable",
        data() {
            return {
                is_loading_table: false,
                is_loading_chunk: false,
                autoload_on_bottom: true,
                bottom: false,

                // Filters
                payload_brands: [],
                selected_brands: [],
                search_brands: null,
                rests_filter_list: [
                    {value: 0, text: 'Все товары'},
                    {value: 1, text: 'Остаток 1+'},
                    {value: 30, text: 'Остаток 30+'},
                    {value: 50, text: 'Остаток 50+'},
                    {value: 100, text: 'Остаток 100+'},
                ],
                rests_value: 1,

                // Search
                search: '',
                // Reset pagination in some cases
                reset_table_page: false,

                // Price
                price_filter_dir: '__gte',
                price_filter_value: 0,

                // Categories
                cat_new: false,
                cat_promo: false,
                cat_sale: false,

                rows_per_page: [25, 50, 100],
                row_expanded: true,
                pagination: {
                    descending: false,
                    sortBy: 'name',
                    rowsPerPage: 25,
                    selected_page: 1
                },
                selected: [],
                headers: [
                    {selected: true, sortable: true, text: 'Наименование', align: 'left', value: 'name', sort_value: 'name' },
                    {selected: true, sortable: true, text: 'Артикул', align: 'left', value: 'article', sort_value: 'article' },
                    {selected: true, sortable: false, text: 'Картинка', align: 'left', value: 'image_path', sort_value: 'image_path' },
                    {selected: false, sortable: false, text: 'Описание', align: 'left', value: 'description', sort_value: 'description' },
                    {selected: true, sortable: true, text: 'Брэнд', align: 'center', value: 'name_brand', sort_value: 'name_brand' },
                    {selected: true, sortable: true, text: 'Цена', align: 'right', value: 'price_user', sort_value: 'price_user.value' },
                    {selected: true, sortable: false, text: 'РРЦ', align: 'right', value: 'price_pub', sort_value: 'price_pub.value' },
                    {selected: true, sortable: true, text: 'Остаток', align: 'right', value: 'rests', sort_value: 'rests.value' },
                ],
                    sort: {
                    name: '',
                    order: 'asc'
                },
                value_sorts: ['price_user', 'price_pub', 'rests'],
                mob_sort_list: [
                    {value: 'name', text: 'Наименование'},
                    {value: 'article', text: 'Артикул'},
                    {value: 'name_brand', text: 'Брэнд'},
                    {value: 'price_user.value', text: 'Цена'},
                    {value: 'rests.value', text: 'Остаток'},
                ],
                payload_list: [],
                payload_meta: {
                    pagination: {
                        page: 1,
                        pages: 0,
                        count: 0,
                    }
                },
                payload_links: {},
                // Order items
                order_item_send_id: '',
                order_item_send_qty: 0,
                order_item_send_price: 0.00,
                // Lightbox
                image_show_fsize: false,
                image_show_path: '',
                // Snack-bar
                snack: {
                    active: false,
                    color: '',
                    text: '',
                    timeout: 6000,
                },
                // Alert - table field
                alert: {
                    color: "primary",
                    icon: "priority_high",
                    text: "Нет данных или они еще не загружены.",
                },
            }
        },
        computed: {
            is_logged_in() { return this.$store.getters.logged_state },
            order_items_list() { return this.$store.getters.order_goods_list_get},
            selected_catalogs() { return this.$store.getters.selected_catalogs},
            selected_catalogs_qs() { return this.$store.getters.selected_catalogs_qs},
            disable_control() { return this.is_loading_table || this.is_loading_chunk }
        },
        created() {
            if(sessionStorage.getItem('auth_token')) {
                $.ajaxSetup({
                    headers: {'Authorization': 'Token ' + sessionStorage.getItem('auth_token')},
                });
            }
            this.load_brands();
            this.load_items();
            this.$eventBus.$on('EVENT_price_view_catalog', this.EVENT_price_view_catalog);
            // autoload chunks
            window.addEventListener('scroll', () => {
                this.bottom = this.bottom_visible();
            });
            this.load_next_chunk();
        },
        mounted() {
            this.session_settings_load();
        },
        watch: {
            bottom(bottom) {
                if (bottom) {
                    this.load_next_chunk();
                }
            }
        },
        beforeDestroy() {
            this.$eventBus.$off();
        },
        methods: {
            // -------------------------------
            // Preloaded data
            load_brands() {
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'svc/brands/',
                    type: 'GET',
                    data: {
                    },
                    success: (response) => {
                        this.payload_brands = response;
                        this.selected_brands = [];
                    },
                    error: () => {
                        this.payload_brands = [];
                        this.selected_brands = [];
                    },
                })
            },
            // -------------------------------
            // Session settings
            session_settings_save() {
                sessionStorage.setItem("pr_rpp", this.pagination.rowsPerPage);
                sessionStorage.setItem("pr_al", this.autoload_on_bottom);
                sessionStorage.setItem("pr_s_desc", this.pagination.descending);
                sessionStorage.setItem("pr_s_val", this.pagination.sortBy);
            },
            session_settings_load() {
                const rpp = Number(sessionStorage.getItem('pr_rpp'));
                if(rpp)
                    if(this.rows_per_page.indexOf(rpp) > -1)
                        this.pagination.rowsPerPage = rpp;
                const pag_sortby = sessionStorage.getItem('pr_s_val');
                if(pag_sortby) {
                    let obj = this.mob_sort_list.find(o => o.value === pag_sortby);
                    if (obj)
                        this.pagination.sortBy = pag_sortby;
                }

                // All stored settings is strings after get.
                const autoload = sessionStorage.getItem('pr_al');
                if(autoload !== null ) {
                    var autoload_bool = false;
                    if(autoload === 'true')
                        autoload_bool = true;
                    this.autoload_on_bottom = autoload_bool;
                }
                const pag_desc = sessionStorage.getItem('pr_s_desc');
                if(pag_desc !== null ) {
                    var pag_desc_bool = false;
                    if(pag_desc === 'true')
                        pag_desc_bool = true;
                    this.pagination.descending = pag_desc_bool;
                }
            },
            // -------------------------------
            // Main methods
            get_load_settings() {
                // Read session params
                // Without it vue will load new created page with data exports defaults
                this.session_settings_load();
                var rs = {
                    proceed_load: true,
                    page: this.pagination.selected_page,
                    brands_string: this.selected_brands.length > 0 ?
                        this.selected_brands.toString() : '',
                    search_string: this.search,
                    ids: this.selected_catalogs_qs,
                    payload_data: null,
                };
                // Change of some settings require to reset pagination
                if(this.reset_table_page) {
                    rs.page = 1;
                    this.pagination.selected_page = 1;
                }
                this.reset_table_page = false;

                if (rs.ids === '' && !this.selected_catalogs.all) {
                    this.show_alert('primary', 'touch_app', 'Выберите каталоги для отображения.')
                    this.drop_table();
                    rs.proceed_load = false;
                    return rs;
                }
                if (this.selected_catalogs.all)
                    rs.ids = '';

                rs.payload_data = {
                        search: rs.search_string,
                        id_brand__in: rs.brands_string,
                        id_parent__in: rs.ids,
                        'page[number]': rs.page,
                        'page[size]': this.pagination.rowsPerPage,
                };
                if (this.cat_new)
                    rs.payload_data['category_new'] = 1;
                if (this.cat_promo)
                    rs.payload_data['category_promo'] = 1;
                if (this.cat_sale)
                    rs.payload_data['category_sale'] = 1;
                // Rests filter
                if (this.rests_value > 0)
                    rs.payload_data['rests__value__gte'] = this.rests_value;

                // Sorting
                if (this.pagination.sortBy !== 'price_user.value') {
                    rs.payload_data['ordering'] = (this.pagination.descending ? '-' : '')
                        + this.pagination.sortBy.replace('.', '__');
                } else {
                    rs.payload_data['ordering'] = 'prices__id_price,'
                        + (this.pagination.descending ? '-' : '')
                        + 'prices__value';
                }
                // Filter price
                if( this.price_filter_value > 0){
                    rs.payload_data['price_user'+this.price_filter_dir] = this.price_filter_value;
                }
                return rs;
            },
            load_items() {
                var sta = this.get_load_settings();
                if (!sta.proceed_load)
                    return;
                this.is_loading_table = true;
                this.show_alert('accent', 'update', 'Идет загрузка...');
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'goods/',
                    type: 'POST',
                    data: sta.payload_data,

                    success: (response) => {
                        if (this.is_loading_chunk)
                            this.payload_list = this.payload_list.concat(response.results);
                        else
                            this.payload_list = response.results;
                        this.payload_meta = response.meta;
                        this.payload_links = response.links;
                        this.pagination.selected_page = this.payload_meta.pagination.page;
                        // stop loading animation
                        // Show Nothing found error
                        if (this.payload_meta.pagination.count === 0){
                            this.show_alert('primary', 'priority_high', 'Ничего не найдено в текущем представлении!')
                        }
                    },
                    error: (response) => {
                        if (response.status === 400){
                            this.show_alert('primary', 'priority_high', 'HTTP 400: Bad request!')
                        } else {
                            this.show_alert('primary', 'priority_high', 'Нет данных!')
                        }
                        // set defaults
                        this.drop_table();
                    },
                    complete: () => {
                        this.stop_loading();
                    }
                })
            },
            // -------------------------------
            // Table MISC. Reset and others
            drop_table() {
                this.payload_list = [];
                this.payload_meta = {
                    pagination: {
                        page: 1,
                        pages: 0,
                        count: 0,
                    }
                };
                this.pagination.selected_page = 1;
                this.payload_links = {};
                // stop loading animation
                this.stop_loading();
            },
            // -------------------------------
            // Table settings
            // Rows per page, sort and pagination
            navigate_pagination(page_num) {
                this.pagination.selected_page = page_num;
                if(page_num != this.payload_meta.pagination.page) {
                    this.load_items();
                    $(window).scrollTop(0);
                }
            },
            pagination_change_rowsPerPage() {
                this.reset_table_page = true;
                this.session_settings_save();
                this.load_items();
            },
            change_sort(column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column
                    this.pagination.descending = false
                }
                this.session_settings_save();
                this.load_items();
            },
            mob_change_sort() {
                this.session_settings_save();
                this.load_items();
            },
            // -------------------------------
            // Filters on page
            filter_by_category(category) {
                this.reset_table_page = true;
                if (category === 'new'){
                    this.cat_promo = false;
                    this.cat_sale = false;
                }
                if (category === 'promo'){
                    this.cat_new = false;
                    this.cat_sale = false;
                }
                if (category === 'sale'){
                    this.cat_new = false;
                    this.cat_promo = false;
                }
                this.load_items();
            },
            filter_brands(clear_input){
                if(clear_input)
                   this.selected_brands = [];
                this.reset_table_page = true;
                this.load_items();
            },
            perform_search(clear_input) {
                if(clear_input)
                    this.search = '';
                this.reset_table_page = true;
                this.load_items();
            },
            toggle_price_dir() {
                this.price_filter_dir === '__gte' ?
                    this.price_filter_dir = '__lte' : this.price_filter_dir = '__gte';
                this.perform_filter_price(false);
            },
            perform_filter_price(clear_input){
                if(clear_input)
                    this.price_filter_value = 0;
                this.reset_table_page = true;
                this.load_items();
            },
            toggle_rests_view() {
                this.load_items();
            },
            // -------------------------------
            // In-row add items to cart
            // Only for autheticated users
            open_item_to_cart(){
                this.order_item_send_qty = 1;
            },
            save_item_to_cart(item, qty){
                if (qty < 1) {
                    this.show_snack('error', 'Некорректное количество', 6000);
                    return;
                }
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.MAIN + 'post/orderitems/',
                    type: 'POST',
                    data: {
                        item: item.id,
                        quantity: qty,
                        price: item.price_user.value,
                    },
                    success: () => {
                        this.show_snack('success', 'Добавлено в заказ', 6000);
                        this.$store.dispatch('order_info_init');
                    },
                    error: (response) => {
                        this.show_snack('error', 'Ошибка: ' + response.responseJSON.detail, 10000);
                    },
                })
            },
            // -------------------------------
            // Global event calls
            EVENT_price_view_catalog(){
                this.drop_table();
                this.load_items();
            },
            // -------------------------------
            // Lightbox
            view_image(image_path){
                this.image_show_fsize = true;
                this.image_show_path = image_path;
            },
            close_image(){
                this.image_show_fsize = false;
                this.image_show_path = '';
            },
            // -------------------------------
            // Form MISC
            bottom_visible() {
                const scrollY = window.scrollY;
                const visible = document.documentElement.clientHeight;
                const pageHeight = document.documentElement.scrollHeight;
                const bottomOfPage = visible + scrollY >= pageHeight;
                return bottomOfPage || pageHeight < visible;
            },
            load_next_chunk() {
                if (this.is_loading_chunk || !this.autoload_on_bottom)
                    return;
                if (this.payload_meta.pagination.pages > this.pagination.selected_page) {
                    this.pagination.selected_page += 1;
                    this.is_loading_chunk = true;
                    this.load_items();
                }
            },
            stop_loading() {
                this.is_loading_chunk = false;
                this.is_loading_table = false;
            },
            show_snack(snack_color, snack_text, snack_timeout){
                this.snack.active = true;
                this.snack.color = snack_color;
                this.snack.text = snack_text;
                this.snack.timeout = snack_timeout;
            },
            show_alert(alert_color, alert_icon, alert_text) {
                this.alert.color = alert_color;
                this.alert.icon = alert_icon;
                this.alert.text = alert_text;
            },
            catalog_toggle() {
                this.$store.dispatch('catalog_toggle');
            },
        },
        filters: {
            TO_PRICE(value) {
                if(value)
                    return `₽ ${value.toLocaleString()}`;
                else
                    return "--";
            },
        },
    }
</script>

<style scoped>

</style>